import { useMemo, useRef } from 'react';

import {
  serializeRegionToMarket,
  STATIC_REGION_MARKET_TOKENS,
  type MarketToken,
  type OpportunityCardItem,
} from '@/entities/opportunity';

export function useOpportunitiesRoomFilters(opportunities: OpportunityCardItem[]) {
  const marketCache = useRef(new Set<MarketToken>());
  const audienceCache = useRef(new Set<string>());

  const marketOptions = useMemo(() => {
    opportunities.forEach((opp) => {
      if (opp.region?.level === 'country') {
        marketCache.current.add(serializeRegionToMarket(opp.region));
      }
    });
    const countryTokens = Array.from(marketCache.current).sort();
    return [...STATIC_REGION_MARKET_TOKENS, ...countryTokens];
  }, [opportunities]);

  const audienceOptions = useMemo(() => {
    opportunities.forEach((opp) => {
      opp.targetAudienceProfiles?.forEach((profile) => {
        const name = profile.segmentName.trim();
        if (name) audienceCache.current.add(name);
      });
    });
    return Array.from(audienceCache.current).sort();
  }, [opportunities]);

  const flashOpportunities = useMemo(
    () => opportunities.filter((opp) => opp.durationType?.value === 'flash'),
    [opportunities],
  );

  const otherOpportunities = useMemo(
    () => opportunities.filter((opp) => opp.durationType?.value !== 'flash'),
    [opportunities],
  );

  return {
    flashOpportunities,
    otherOpportunities,
    marketOptions,
    audienceOptions,
  };
}
